export default __webpack_public_path__ + "static/media/W51Bath3.f79a3b74.jpg";